<!-- Loader -->
<div *ngIf="loading"
     class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
  <i class="fas fa-spinner fa-spin text-6xl" style="color:#c19725;"></i>
</div>

<div class="w-full px-4 py-4" *ngIf="!loading">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <div class="w-10 h-10 flex items-center justify-center rounded-full bg-[#f6f1cb]">
      <img src="/assets/images/stock/return.png" class="w-6 h-6" />
    </div>
    <h2 class="text-xl font-semibold text-444">
      Returned Raw Materials
    </h2>
  </div>

  <!-- Empty State -->
  <div *ngIf="returnedOrders.length === 0"
       class="text-center py-14 text-gray-500">
    No returned raw materials found.
  </div>

  <!-- Cards -->
  <div class="space-y-5" *ngIf="returnedOrders.length">

    <div *ngFor="let order of returnedOrders"
         class="relative bg-white rounded-xl shadow-md
                hover:shadow-lg transition-all duration-300
                border border-[#eee]">

      <!-- Left Accent -->
      <div class="absolute left-0 top-0 h-full w-1 rounded-l-xl bg-c19725"></div>

      <div class="p-5 pl-6">

        <!-- Top Row -->
        <div class="flex justify-between items-start mb-3">
          <div>
            <h3 class="text-lg font-semibold text-gray-800">
              {{ order.product_name }}
            </h3>
            <p class="text-sm text-gray-500">
              Code: <span class="font-medium">{{ order.product_code }}</span>
            </p>
          </div>

          <span
            class="px-3 py-1 text-xs font-semibold rounded-full
                   bg-blue-100 text-blue-700">
            Returned
          </span>
        </div>

        <!-- Quantity -->
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 flex items-center justify-center rounded-full bg-[#f6f1cb]">
            <i class="fas fa-box text-[#c19725] text-sm"></i>
          </div>
          <p class="text-sm text-gray-700">
            Quantity Returned:
            <span class="font-semibold text-gray-900">
              {{ order.quantity }}
            </span>
          </p>
        </div>

        <!-- Divider -->
        <div class="border-t border-dashed border-gray-200 my-3"></div>

        <!-- Bottom Meta -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">

          <div class="flex items-center gap-2">
            <i class="fas fa-user text-gray-400"></i>
            <div>
              <p class="text-gray-500 text-xs">Assignee</p>
              <p class="font-medium text-gray-800">
                {{ order.assignee_name || '—' }}
              </p>
            </div>
          </div>

          <div class="flex items-center gap-2">
            <i class="fas fa-calendar-alt text-gray-400"></i>
            <div>
              <p class="text-gray-500 text-xs">Returned On</p>
              <p class="font-medium text-gray-800">
                {{ order.updated_at | date:'dd MMM yyyy, hh:mm a' }}
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</div>
